export class TransmissionStation {
    id: number = 0;
    name: string = "";
    code: string = "";
    utilityId: number = 0;
    guid: string = "";
}